import dayjs from "dayjs";
import {
  Button, Typography, Space, Card, Flex, Dropdown, Divider, Spin, Row, Col
} from "antd";
import { LeftOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import useScheduler from "./useScheduler";
import { DoctorData, SchedulerProps, TimeType } from "../../types/scheduler";
import classes from "./scheduler.module.css";

const { Text } = Typography;

const Scheduler = (props: SchedulerProps & { doctorData?: DoctorData }) => {
  const {
    doctorData,
    onTimeClick,
    defaultDay = dayjs(), // get today's day by default
    defaultDays = 5,
    size = "normal"
  } = props;

  const {
    items,
    currentMonth,
    handlePrev,
    handleNext,
    currentRange,
    handleOnSelect,
    isCurrentWeek,
    days,
    isSchedulerLoading: loading,
    selectedSchedules,
    setSelectedSchedules
  } = useScheduler({
    defaultDay,
    defaultDays,
    doctorData
  });

  const rootClass = size === "small" ? classes.rootSmall : classes.root;

  const scheduleButtonClass = (schedule: TimeType) => {
    if (schedule.current === selectedSchedules?.current
      && schedule.from === selectedSchedules?.from) {
      return classes.buttonSelected;
    }

    if (schedule.disabled) return classes.buttonDisabled;

    return classes.button;
  };

  return (
    <div className={rootClass}>
      <Spin spinning={loading}>
        <Flex justify="center" className={classes.header}>
          <Dropdown
            menu={{
              items,
              selectable: true,
              defaultSelectedKeys: ["0"],
              onSelect: (menuItem) => handleOnSelect(menuItem)
            }}
            trigger={["click"]}
          >
            <Typography.Link>
              <Space>
                <Text strong className={classes.monthSwitcherLabel}>
                  {currentMonth}
                </Text>
                <DownOutlined />
              </Space>
            </Typography.Link>
          </Dropdown>
        </Flex>
      </Spin>
      <Divider className={classes.divider} />
      <Flex gap={10}>
        <Button
          type="text"
          onClick={() => handlePrev()}
          icon={<LeftOutlined/>}
          style={{ marginTop: 23 }}
          disabled={isCurrentWeek}
        />
        <Row gutter={10} style={{ flexGrow: 1 }}>
          {currentRange ? currentRange.map((item) => (
            <Col key={item.date.toISOString()} flex={`${100 / days}%`}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Card size="small">
                  <Space size={0} direction="vertical" style={{ width: "100%", textAlign: "center" }}>
                    <Text strong className={classes.day}>
                      {dayjs(item.date).date()}
                    </Text>
                    <Text type="secondary" className={classes.weekDay}>
                      {dayjs(item.date).format("dddd")}
                    </Text>
                  </Space>
                </Card>
                <Space size={10} direction="vertical" className={classes.appointments}>
                  {item.schedules?.map((schedule) => (
                    <Button
                      type="primary"
                      key={schedule.time}
                      disabled={schedule.disabled}
                      onClick={
                        schedule.disabled ? undefined : () => {
                          setSelectedSchedules(schedule);
                          onTimeClick(schedule);
                        }
                      }
                      block
                      className={`${scheduleButtonClass(schedule)} btn-standart`}
                    >
                      {schedule.time}
                    </Button>
                  ))}
                </Space>
              </Space>
            </Col>
          )) : null}
        </Row>
        <Button
          type="text"
          onClick={() => handleNext()}
          icon={<RightOutlined/>}
          style={{ marginTop: 23 }}
        />
      </Flex>
    </div>
  );
};

export default Scheduler;
